<template>
    <footer class="footer">
      <div class="footer-container">
        <div class="footer-wrap">
          <div class="footer-top">
            <div class="footer-top__left">
              <div class="footer-contacts">
                <div class="footer-contacts__mail">
                  <span><i class="fas fa-envelope"></i></span>
                  <a href="mailto:info@elmeh.ru" class="footer-links">info@elmeh.ru</a>
                </div>
                <div class="footer-contacts__phone">
                  <span><i class="fas fa-phone fa-flip-horizontal"></i></span>
                  <div class="footer-contacts__phone-wrap">
                    <a href="tel:88007009802">8 800 700 98 02</a>
                    <a href="tel:+78412209000">+7 8412 209-000</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="footer-top__right">
              <div class="footer-contacts__adress">
                <span class="link-icons"><i class="fas fa-map-marker-alt"></i></span>
                <span>г. Пенза, ул. Гоголя, 51/53</span>
              </div>
              <div class="footer-contacts__policy">
                <span class="link-icons"><i class="fas fa-file-contract"></i></span><a href="https://www.elmeh.ru/company/consent.php" target="_blank" class="footer-links">Политика конфиденциальности</a>
                <br>
                <span class="link-icons"><i class="fas fa-file-contract"></i></span><a href="https://www.elmeh.ru/company/uvedomlenie-ob-ispolzovanii-faylov-cookie/" target="_blank" class="footer-links">Уведомление об использовании файлов cookie</a>
              </div>
            </div>
          </div>
          <div class="footer-bottom">
            <p class="footer-copyright">© {{ currentYear }} Все права защищены</p>
          </div>
        </div>
      </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
    data() {
    return {
      currentYear: new Date().getFullYear(),
    }
  }
}
</script>

<style lang="sass">
.footer
  flex: 0 0 auto
  background-color: #f5f5f5
  &-container
    max-width: 1384px
    min-width: 320px
    margin: 0 auto
  &-wrap
    margin-right: 20px
    margin-left: 20px
  &-top
    padding: 10px 0
    display: flex
    justify-content: space-between
    @media screen and (min-width: 970px)
      flex-direction: row
    @media screen and (max-width: 969px)
      flex-direction: column
    &__left
      @media screen and (min-width: 970px)
        width: 480px
      .footer-contacts
        display: flex
        justify-content: space-between
        align-items: center
        @media screen and (min-width: 970px)
          flex-direction: row
        @media screen and (max-width: 969px)
          flex-direction: column
    &__right
      @media screen and (min-width: 970px)
        width: 480px
      @media screen and (max-width: 969px)
        margin-top: 15px
  &-bottom
    padding-bottom: 20px
  &-contacts
    display: flex
    &__mail
      @media screen and (max-width: 969px)
          margin: 10px 0
      span
        margin-right: 10px
    &__phone
      display: flex
      flex-direction: row
      align-items: center
      @media screen and (max-width: 969px)
          order: -1
      span
        margin-right: 10px
      a
        color: #2d2d2d
        font-size: 16px
        font-weight: bold
      &-wrap
        display: flex
        flex-direction: column
    &__policy
      margin-top: 10px
  &-copyright
    font-size: 13px
    line-height: 1.5
    color: #2d2d2d
    @media screen and (max-width: 969px)
      text-align: center
  &-links
    &:hover
      text-decoration: underline
.link-icons
  margin-right: 10px
</style>